import { useRef, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useExcel } from '../../../hooks/useExcel';
import useTranslations from '../../../hooks/useTranslations';

interface CSVLinkContainerProps {
  columns: any[];
  getData: () => Promise<any>;
  mapData: (data: any) => any[];
  disabled: boolean;
  fileNamePrefix: string;
}

const CSVLinkContainer = ({
  columns,
  getData,
  mapData,
  disabled,
  fileNamePrefix,
}: CSVLinkContainerProps) => {
  const { rcTranslate } = useTranslations();
  const { generateExcelData } = useExcel();
  const csvLinkRef = useRef<any>(null);
  const [csvData, setCsvData] = useState<any[]>([]);

  const handleExportClick = async () => {
    try {
      const data = await getData();
      const rows = mapData(data);
      const excelData = generateExcelData(columns, rows);
      setCsvData(excelData);
      csvLinkRef.current.link.click();
    } catch (error) {
      console.error('Error fetching data for CSV export:', error);
    }
  };

  return (
    <>
      <button
        className={`buttonComponent buttonComponent__outlined button__exportCSV ${
          disabled ? 'buttonComponent__disabled' : ''
        }`}
        onClick={handleExportClick}
        disabled={disabled}
      >
        {rcTranslate('button.exportCSV')}
      </button>
      <CSVLink
        ref={csvLinkRef}
        data={csvData}
        filename={`${fileNamePrefix}_${new Date().toLocaleDateString('he-IL').replaceAll('.', '-')}.csv`}
        style={{ display: 'none' }}
        target="_blank"
      />
    </>
  );
};

export default CSVLinkContainer;
